export const STORAGE_KEY = 'uniqms'

const licenceData = {
  expiryDate: '',
  isExpired: true,
  isExpiring: true,
  isGracePeriod: false
}

export default {
  licenceExpired: true,
  licenceData,
  showSpinnerRequestCount: 0,
  spinnerMessage: 'Loading...',
  jwtToken: ''
}
